/* unplugin-vue-components disabled */import __unplugin_components_3 from 'F:/bio_link_pc/src/components/common/commonItem.vue';
import { ElTabs as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tabs/style/css';
import { ElTabPane as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/tab-pane/style/css';
import __unplugin_components_0 from 'F:/bio_link_pc/src/components/common/inputSend.vue';
import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "input_row"
};
var _hoisted_2 = {
  key: 0,
  class: "like_row"
};
var _hoisted_3 = {
  class: "like_users"
};
var _hoisted_4 = {
  class: "tip"
};
var _hoisted_5 = {
  key: 0,
  class: "tab-comment"
};
var _hoisted_6 = {
  key: 1
};
var _hoisted_7 = ["onClick"];
var _hoisted_8 = {
  key: 2
};
var _hoisted_9 = {
  class: "visit_log_left"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  key: 1,
  class: "avatar_img",
  src: "https://www.bio-cloud.com.cn:8022/icon/blk.jpg"
};
var _hoisted_12 = {
  class: "name"
};
var _hoisted_13 = {
  class: "visit_log_right"
};
import { get_business_comment, set_business_comment, set_like, get_like, get_visit_read_log } from "@/api/apis";
import { watch, watchEffect } from "vue";
import { randomColor } from "@/util/index";
import { useUserStore } from "@/store/user";
import { ElMessage } from "element-plus";
export default {
  __name: 'commonArea',
  props: ["id", "comment_type", "showLike", "showVisit"],
  setup(__props) {
    var userStore = useUserStore();
    var props = __props;
    function tree(x, arr, children) {
      var item = arr.find(a => a.comment_id == x.id);
      if (item) {
        children.push(item);
        tree(item, arr, children);
      }
    }
    var activeName = ref("1");
    var getArr = arr => {
      var leve1_arr = arr.filter(x => {
        return !x.comment_id;
      });
      leve1_arr.map(x => {
        x.children = [];
        x.is_show = false;
        tree(x, arr, x.children);
      });
      return leve1_arr;
    };

    /**
     * 根据层级获取评论内容
     */
    var common_list = ref([]);
    var get_comment = () => {
      get_business_comment({
        id: props.id,
        comment_type: props.comment_type
      }).then(res => {
        if (res.code == 200) {
          var temp_user_list = res.data.data.map(x => {
            return {
              username: x.businesses_comment_user[0].name,
              uid: x.businesses_comment_user[0].id
            };
          });
          userStore.set_user_color(temp_user_list);
          common_list.value = getArr(res.data.data);
        }
      });
    };
    /**
     * 获取点赞
     */
    var like_users = ref([]);
    var is_me_like = ref(0);
    var like_list = () => {
      get_like({
        liked_user_id: props.id
      }).then(res => {
        if (res.code == 200) {
          var _res$data$list$find;
          is_me_like.value = ((_res$data$list$find = res.data.list.find(x => x.liked_post_id == userStore.info.id)) === null || _res$data$list$find === void 0 ? void 0 : _res$data$list$find.id) || 0;
          var temp_user_list = res.data.list.map(x => {
            return {
              username: x.user_info.name,
              uid: x.user_info.id
            };
          });
          userStore.set_user_color(temp_user_list);
          like_users.value = res.data.list;
        }
      });
    };
    var handle_like = () => {
      var methods = "POST";
      var obj = {};
      if (is_me_like.value) {
        obj = {
          id: is_me_like.value
        };
        methods = "put";
      } else {
        obj = {
          liked_user_id: props.id,
          type: 1
        };
      }
      set_like(obj, methods).then(res => {
        if (res.code == 200) {
          ElMessage({
            type: "success",
            message: is_me_like.value ? "取消点赞成功" : "点赞成功"
          });
          like_list();
        }
      });
    };
    // 评论
    var remark_text = ref("##");
    var handleSend = val => {
      var obj = {
        businesses_id: props.id,
        comment_type: props.comment_type,
        content: val
      };
      if (!obj.content) {
        ElMessage({
          type: "warning",
          message: "请填写评论内容"
        });
        return;
      }
      set_business_comment(obj, "post").then(res => {
        if (res.code == 200) {
          get_comment();
        }
      });
    };
    var handle_success = () => {
      get_comment();
    };

    //获取浏览记录
    var visit_log = ref([]);
    var get_visit_log = () => {
      get_visit_read_log({
        origin_id: props.id
      }).then(res => {
        if (res.code == 200) {
          var _res$data;
          visit_log.value = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
        }
      });
    };
    watch(() => {
      return props.id;
    }, () => {
      get_comment();
      like_list();
      get_visit_log();
    }, {
      immediate: true
    });
    watch(() => {
      return props.showVisit;
    }, () => {}, {
      immediate: true
    });
    watch(() => {
      return props.showLike;
    }, () => {}, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _component_input_send = __unplugin_components_0;
      var _component_el_tab_pane = __unplugin_components_1;
      var _component_el_tabs = __unplugin_components_2;
      var _component_common_item = __unplugin_components_3;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_input_send, {
        style: {
          "flex": "1"
        },
        onOnSend: handleSend
      })]), __props.showLike ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(like_users), (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: "user_box",
          key: index,
          style: _normalizeStyle({
            'background-color': _unref(userStore).user_list_color[item.user_info.id]
          })
        }, _toDisplayString(item.user_info.name.substr(-1)), 5);
      }), 128)), _createElementVNode("span", _hoisted_4, " 等" + _toDisplayString(_unref(like_users).length) + "人点赞 ", 1)]), _createElementVNode("span", {
        class: _normalizeClass(['iconfont', 'icon-dianzan_kuai', _unref(is_me_like) ? 'liked' : '']),
        onClick: handle_like
      }, null, 2)])) : _createCommentVNode("", true)]), __props.showVisit ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_tabs, {
        modelValue: _unref(activeName),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(activeName) ? activeName.value = $event : null),
        class: "tab-comment"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "评论",
          name: "1"
        }), _createVNode(_component_el_tab_pane, {
          label: "浏览记录",
          name: "2"
        })]),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true), _unref(activeName) == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(common_list), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index
        }, [_createVNode(_component_common_item, {
          common: item,
          id: __props.id,
          comment_type: __props.comment_type,
          onOnSuccess: handle_success
        }, null, 8, ["common", "id", "comment_type"]), item.is_show ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(item.children, (item2, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "huifu",
            key: index
          }, [_createVNode(_component_common_item, {
            common: item2,
            onOnSuccess: handle_success,
            id: __props.id,
            comment_type: __props.comment_type
          }, null, 8, ["common", "id", "comment_type"])]);
        }), 128)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("p", {
          class: "show_btn",
          onClick: $event => item.is_show = !item.is_show
        }, [_createTextVNode(_toDisplayString(item.is_show ? "收起评论" : "展开评论") + " ", 1), _createElementVNode("span", {
          class: _normalizeClass(['iconfont', item.is_show ? 'icon-jiantoushang' : 'icon-jiantouxia'])
        }, null, 2)], 8, _hoisted_7), [[_vShow, item.children && item.children.length != 0]])]);
      }), 128))])) : _createCommentVNode("", true), _unref(activeName) == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visit_log), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "visit_log_box"
        }, [_createElementVNode("div", _hoisted_9, [item.user_avatar ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.user_avatar,
          class: "avatar_img"
        }, null, 8, _hoisted_10)) : (_openBlock(), _createElementBlock("image", _hoisted_11)), _createElementVNode("span", _hoisted_12, _toDisplayString(item.user_name), 1)]), _createElementVNode("div", _hoisted_13, _toDisplayString(item.created_at), 1)]);
      }), 128))])) : _createCommentVNode("", true)], 64);
    };
  }
};